import DealerSpecificPromotional from './DealerSpecificPromotional'
export default DealerSpecificPromotional
